import { render } from "./MatchedCardInfo.vue?vue&type=template&id=7ad60d0f&ts=true"
import script from "./MatchedCardInfo.vue?vue&type=script&lang=ts"
export * from "./MatchedCardInfo.vue?vue&type=script&lang=ts"

import "./MatchedCardInfo.vue?vue&type=style&index=0&id=7ad60d0f&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__